import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgOptimizedImage} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {RouterLink} from "@angular/router";
import {LoadingComponent} from "../../loading/loading.component";

@Component({
  selector: 'app-button-with-icon',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslateModule,
    RouterLink,
    NgClass,
    LoadingComponent
  ],
  template: `
    <button class="d-inline-flex justify-content-between align-items-center global-button px-3 py-2 "
            [ngClass]="[displayRow, additionalClass ? additionalClass: 'custom-button']"
            (click)="clickHandler()">
      @if (isLoading) {
        <div class="d-flex align-items-center justify-content-center">
          <span class="me-2"> {{ loadingText | translate }} </span>
          <app-loading [size]="'small'"></app-loading>
        </div>
      } @else {
        <div>{{ label | translate: getParam() }}</div>
        @if (icon !== '') {
          <div [ngClass]="{'ms-2': label}">
            <img [ngSrc]="icon" width="24" height="24" alt="{{label}}"/>
          </div>
        }
        @if (iconClass !== '') {
          <div [ngClass]="{'ms-2 me-2': label}">
            <i class="{{iconClass}}"></i>
          </div>
        }
      }

    </button>

  `,
  styleUrl: './button-with-icon.component.scss'
})
export class ButtonWithIconComponent {


  @Input() isTransparent = false;
  @Input() isLoading = false;
  @Input() disabled = false;
  @Input() loadingText = '';
  @Input() label = '';
  @Input() icon = '';
  @Input() iconClass = '';
  @Input() displayRow = 'flex-row';
  @Input() additionalClass = '';
  @Output() buttonClickHandler: EventEmitter<void> = new EventEmitter();

  @Input() buttonLabelParam?: string;
  getParam() {
    if (this.buttonLabelParam) {
      return {value: this.buttonLabelParam}
    }
    return {value: ''}
  }
  clickHandler() {
    if(!this.disabled) {
      this.buttonClickHandler.emit();
    }
  }
}
